module.exports = __webpack_public_path__ + "testimonial-logo-built.1_uSRNC2.svg";